import React, { memo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from "highcharts/highcharts-more";
import { useTheme } from '@mui/material';
import { getChartA11yOptions } from '../../../utils/highchartsAccessibility';

highchartsMore(Highcharts);
interface CustomGaugeChartProps {
    data: number
}
const CustomGaugeChart = memo(function CustomGaugeChart(props: CustomGaugeChartProps): JSX.Element {
    const theme = useTheme();
    const a11y = getChartA11yOptions({
        altText: 'Score gauge chart',
        description: `Gauge chart showing a score value of ${props?.data} out of 100.`,
    });
    const options = {
        tooltip: {
            enabled: false
        },
        chart: {
            animation: true,
            // height: 300,
            style: {
                fontFamily: `${theme.typography.fontFamily}`,
                borderWidth: 0
            },
            backgroundColor: `${theme.palette.common.white}`,
            spacingBottom: 0,
            description: a11y.chartDescription,
        },
        title: a11y.title,
        accessibility: a11y.accessibility,
        pane: {
            center: ['50%', '50%'],
            size: '100%',
            startAngle: -150,
            endAngle: 150,
            background: [{
                borderWidth: 0,
                backgroundColor: theme.palette.common.white,
            }]
        },
        yAxis: {
            min: 0,
            max: 101,
            lineWidth: 0,
            minorTickInterval: 'undefined',
            minorTickLength: 0,
            minorTickPosition: 'undefined',
            tickPixelInterval: 50,
            tickWidth: 3,
            tickPosition: 'undefined',
            tickLength: 0,
            labels: {
                enabled: false,
                step: 2,
                rotation: 'auto'
            },
            title: {
                text: ''
            },
            plotBands: [{
                from: 0,
                to: 15,
                color: theme.palette.customGauge.range1,
                thickness: 12,
            }, {
                from: 16,
                to: 30,
                color: theme.palette.customGauge.range2,
                thickness: 12
            }, {
                from: 31,
                to: 45,
                color: theme.palette.customGauge.range3,
                thickness: 12
            },
            {
                from: 46,
                to: 60,
                color: theme.palette.customGauge.range4,
                thickness: 12
            },
            {
                from: 61,
                to: 101,
                color: theme.palette.customGauge.range5,
                thickness: 12,
            }
            ]
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            series: {
                center: ['50%', '115%']
            }
        },
        series: [{
            type: 'gauge',
            data: [Math.min(100, props?.data)],
            dataLabels: {
                enabled: false,
                useHTML: true,
                align: 'center',
                formatter: function (this: any) {
                    return '<span style="color:grey;">' + 'Score' + '</span><br/>' +
                        '<span style="color:black;font-weight:bold;font-size: 24px;">' + props?.data + '</span>'
                },
                borderWidth: 0
            },
            dial: {
                radius: '90%',
                backgroundColor: 'gray',
                baseWidth: 12,
                baseLength: '0%',
                rearLength: '0%',
                // Change the needle type to arrow
                arrowLength: 10,
                arrowWidth: 6,
                shape: 'arc'
                // Arrow color
            }
        },
        ]
    };
    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
            containerProps={{ style: { height: '100%', width: "100%" } }}
        />
    )
})
export default CustomGaugeChart
